import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';

import * as Sentry from '@sentry/react';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import App from './App';
import { BrandingProvider } from './contexts/BrandingContext';
import { FileTransferProvider } from './contexts/FileDownloadContext';
import { FileUploadProvider } from './contexts/FileUploadContext';
import { ModalProvider } from './contexts/ModalContext';
import { TagsProvider } from './contexts/TagsContext';
import './index.css';
import './utils/i18n';
import AntdConfigProvider from './components/Core/AntdConfigProvider';

const isLocalhost = window.location.hostname === 'localhost';

if (!isLocalhost) {
  Sentry.init({
    dsn: 'https://3a811faf3b3f7f28d609dd26130d0627@o4506936690147328.ingest.us.sentry.io/4508478650449920',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: import.meta.env.MODE,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AntdConfigProvider>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ModalProvider>
        <BrandingProvider>
          <AuthProvider>
            <TagsProvider>
              <PermissionsProvider>
                <FileUploadProvider>
                  <FileTransferProvider>
                    <App />
                  </FileTransferProvider>
                </FileUploadProvider>
              </PermissionsProvider>
            </TagsProvider>
          </AuthProvider>
        </BrandingProvider>
      </ModalProvider>
    </BrowserRouter>
  </AntdConfigProvider>,
);
